import { render, staticRenderFns } from "./BulkOperations.vue?vue&type=template&id=33f9ce21&scoped=true"
import script from "./BulkOperations.vue?vue&type=script&lang=js"
export * from "./BulkOperations.vue?vue&type=script&lang=js"
import style0 from "./BulkOperations.vue?vue&type=style&index=0&id=33f9ce21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9ce21",
  null
  
)

export default component.exports